import React from "react";
import FacilityConstants from "../constants/FacilityConstants";
import {
  Phone,
  PhoneCall,
  MessageCircle,
  Mail,
  MessagesSquare,
} from "lucide-react";

/**
 * ContactInfo component
 * @param {boolean} param0 - The column layout of the contact info.
 * @returns  The contact info component.
 */
const ContactInfo = ({ columnLayout }) => {
  const chatMediums = [
    {
      medium: "SMS",
      href: `sms:${FacilityConstants.PHONE.format4}`,
      icon: MessageCircle,
      value: FacilityConstants.PHONE.format2,
    },
    {
      medium: "Email",
      href: `mailto:${FacilityConstants.EMAILS.info}`,
      icon: Mail,
      value: FacilityConstants.EMAILS.info,
    },
  ];
  return (
    <div
      className={`grid gap-6 grid-cols-1 text-white my-4 mx-2 md:mx-6 ${
        columnLayout
          ? "items-stretch"
          : " items-stretch md:grid-cols-2 xl:grid-cols-2"
      }`}
    >
      <div className="flex bg-slate-200 dark:bg-slate-800 rounded-md py-6 px-4 transition-colors duration-300 h-full">
        <div className="flex flex-col items-start gap-3">
          <div className="flex flex-row items-center gap-3">
            <div className="p-3 rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400">
              <Phone size={28} strokeWidth={1.5} />
            </div>
            <h2 className="text-xl text-slate-900 dark:text-white font-semibold">
              Call Us
            </h2>
          </div>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            We're here to help
          </p>
          <a
            href={`tel:${FacilityConstants.PHONE.format4}`}
            className="flex items-center gap-2 px-4 py-2 bg-green-100 dark:bg-green-900/30 rounded-lg text-green-700 dark:text-green-400 font-semibold hover:bg-green-200 dark:hover:bg-green-900/50 transition-colors"
          >
            <PhoneCall size={20} strokeWidth={1.5} />
            {FacilityConstants.PHONE.format2}
          </a>
        </div>
      </div>

      <div className="flex bg-slate-200 dark:bg-slate-800 rounded-md py-6 px-4 transition-colors duration-300 h-full">
        <div className="flex flex-col items-start gap-3">
          <div className="flex flex-row items-center gap-3">
            <div className="p-3 rounded-xl bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400">
              <MessagesSquare size={28} strokeWidth={1.5} />
            </div>
            <h2 className="text-xl text-slate-900 dark:text-white font-semibold">
              Message Us
            </h2>
          </div>
          <p className="text-sm text-slate-500 dark:text-slate-400">
            We typically respond within 24 hours
          </p>
          {chatMediums.map((medium) => {
            const IconComponent = medium.icon;
            return (
              <a
                key={medium.medium}
                href={medium.href}
                className="flex items-center gap-2 px-4 py-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg text-blue-700 dark:text-blue-400 font-semibold hover:bg-blue-200 dark:hover:bg-blue-900/50 transition-colors"
              >
                <IconComponent size={20} strokeWidth={1.5} />
                {medium.value}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
